import React from 'react';
import '../../../Generals/Styles/FormContainerStyle.css';

const ButtonYellow = (props) => (
  <button
    aria-label="Submit button"
    onClick={props.ifispress}
    style={{ ...props.style, borderRadius: '5px' }}
    type="submit"
    className={`hover-btn btn btn-radius yellow ${props.className || ''}`}
    disabled={props.disabled}>
    {props.title}
  </button>
);

export default ButtonYellow;
